package com.anjuros.website.templates.selection.modules

import com.anjuros.website.components.language.ResKey
import com.anjuros.website.templates.selection.util.Res

enum class BlogCard(
    val title:ResKey,
    val image:String,
    val blogSectionList:List<BlogSection>,
    val beginningDisplayText:ResKey,
    val dateDisplay:String,
    val date:Long,
    val pathToArticle:String
) {
    BLOG4(
        title = ResKey.BLOG4_TITLE,
        image = "/how_much_does_a_website_cost.jpg",
        beginningDisplayText = ResKey.BLOG4_DISPLAY_TITLE,
        dateDisplay = "19 October 2026",
        date = 1792368000000L,
        pathToArticle = "/blog/how-much-does-a-website-cost-for-a-sole-trader",
        blogSectionList = listOf(

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION1_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION1_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION1_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG4_SECTION1_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION2_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        ResKey.BLOG4_SECTION2_PARAGRAPH1,
                        blogTableColumn = listOf(
                            BlogTableColumn(
                                ResKey.BLOG4_SECTION2_TABLE_HEADER1,
                                listOf(
                                    ResKey.BLOG4_SECTION2_ROW1_COL1,
                                    ResKey.BLOG4_SECTION2_ROW2_COL1,
                                    ResKey.BLOG4_SECTION2_ROW3_COL1,
                                    ResKey.BLOG4_SECTION2_ROW4_COL1,
                                    ResKey.BLOG4_SECTION2_ROW5_COL1,
                                    ResKey.BLOG4_SECTION2_ROW6_COL1,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG4_SECTION2_TABLE_HEADER2,
                                listOf(
                                    ResKey.BLOG4_SECTION2_ROW1_COL2,
                                    ResKey.BLOG4_SECTION2_ROW2_COL2,
                                    ResKey.BLOG4_SECTION2_ROW3_COL2,
                                    ResKey.BLOG4_SECTION2_ROW4_COL2,
                                    ResKey.BLOG4_SECTION2_ROW5_COL2,
                                    ResKey.BLOG4_SECTION2_ROW6_COL2,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG4_SECTION2_TABLE_HEADER3,
                                listOf(
                                    ResKey.BLOG4_SECTION2_ROW1_COL3,
                                    ResKey.BLOG4_SECTION2_ROW2_COL3,
                                    ResKey.BLOG4_SECTION2_ROW3_COL3,
                                    ResKey.BLOG4_SECTION2_ROW4_COL3,
                                    ResKey.BLOG4_SECTION2_ROW5_COL3,
                                    ResKey.BLOG4_SECTION2_ROW6_COL3,
                                )
                            ),
                        )
                    ),
                    BlogParagraph(ResKey.BLOG4_SECTION2_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION3_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION3_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION3_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG4_SECTION3_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION4_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION4_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION4_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION5_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION5_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION5_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION6_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION6_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION6_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION7_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION7_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION7_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION8_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        ResKey.BLOG4_SECTION8_PARAGRAPH1,
                        listPoints = listOf(
                            ResKey.BLOG4_SECTION8_POINT1,
                            ResKey.BLOG4_SECTION8_POINT2,
                            ResKey.BLOG4_SECTION8_POINT3,
                            ResKey.BLOG4_SECTION8_POINT4,
                            ResKey.BLOG4_SECTION8_POINT5,
                            ResKey.BLOG4_SECTION8_POINT6,
                        )
                    ),
                    BlogParagraph(ResKey.BLOG4_SECTION8_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION9_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION9_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION9_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG4_SECTION9_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION10_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        ResKey.BLOG4_SECTION10_PARAGRAPH1,
                        blogTableColumn = listOf(
                            BlogTableColumn(
                                ResKey.BLOG4_SECTION10_TABLE_HEADER1,
                                listOf(
                                    ResKey.BLOG4_SECTION10_ROW1_COL1,
                                    ResKey.BLOG4_SECTION10_ROW2_COL1,
                                    ResKey.BLOG4_SECTION10_ROW3_COL1,
                                    ResKey.BLOG4_SECTION10_ROW4_COL1,
                                    ResKey.BLOG4_SECTION10_ROW5_COL1,
                                    ResKey.BLOG4_SECTION10_ROW6_COL1,
                                    ResKey.BLOG4_SECTION10_ROW7_COL1,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG4_SECTION10_TABLE_HEADER2,
                                listOf(
                                    ResKey.BLOG4_SECTION10_ROW1_COL2,
                                    ResKey.BLOG4_SECTION10_ROW2_COL2,
                                    ResKey.BLOG4_SECTION10_ROW3_COL2,
                                    ResKey.BLOG4_SECTION10_ROW4_COL2,
                                    ResKey.BLOG4_SECTION10_ROW5_COL2,
                                    ResKey.BLOG4_SECTION10_ROW6_COL2,
                                    ResKey.BLOG4_SECTION10_ROW7_COL2,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG4_SECTION10_TABLE_HEADER3,
                                listOf(
                                    ResKey.BLOG4_SECTION10_ROW1_COL3,
                                    ResKey.BLOG4_SECTION10_ROW2_COL3,
                                    ResKey.BLOG4_SECTION10_ROW3_COL3,
                                    ResKey.BLOG4_SECTION10_ROW4_COL3,
                                    ResKey.BLOG4_SECTION10_ROW5_COL3,
                                    ResKey.BLOG4_SECTION10_ROW6_COL3,
                                    ResKey.BLOG4_SECTION10_ROW7_COL3,
                                )
                            ),
                        )
                    ),
                    BlogParagraph(ResKey.BLOG4_SECTION10_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION11_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION11_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION11_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG4_SECTION11_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG4_SECTION11_PARAGRAPH4),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG4_SECTION12_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG4_SECTION12_SUBTITLE1, isSubtitle = true),
                    BlogParagraph(ResKey.BLOG4_SECTION12_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG4_SECTION12_SUBTITLE2, isSubtitle = true),
                    BlogParagraph(ResKey.BLOG4_SECTION12_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG4_SECTION12_SUBTITLE3, isSubtitle = true),
                    BlogParagraph(ResKey.BLOG4_SECTION12_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG4_SECTION12_SUBTITLE4, isSubtitle = true),
                    BlogParagraph(ResKey.BLOG4_SECTION12_PARAGRAPH4),
                    BlogParagraph(ResKey.BLOG4_SECTION12_SUBTITLE5, isSubtitle = true),
                    BlogParagraph(ResKey.BLOG4_SECTION12_PARAGRAPH5),
                )
            ),
        )
    ),
    BLOG3(
        title = ResKey.BLOG3_TITLE,
        image = "/15_features_sole_trader_website_should_have.jpg",
        beginningDisplayText = ResKey.BLOG3_DISPLAY_TITLE,
        dateDisplay = "11 August 2026",
        date = 1783641600000L,
        pathToArticle = "/blog/15-essential-features-every-sole-trader-website-should-have",
        blogSectionList = listOf(

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION1_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION1_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION1_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG3_SECTION1_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION2_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION2_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION2_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION3_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION3_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION3_PARAGRAPH2),
                    BlogParagraph(
                        graphic = listOf(BlogGraphic(
                            graphicImage = "/blog3-mobile-friendly1.png",
                            graphicAlt = "Mobile friendly website",
                            showShadow = false)
                        , BlogGraphic(
                            graphicImage = "/blog3-mobile-friendly2.png",
                            graphicAlt = "Mobile friendly website",
                                showShadow = false)
                    )
                    )
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION4_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION4_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION4_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION5_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION5_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION5_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION6_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION6_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION6_PARAGRAPH2),
                    BlogParagraph(
                        graphic = listOf(BlogGraphic(
                            graphicImage = "/blog3_contact.png",
                            graphicAlt = "Easy contact",
                            showShadow = false)
                        )
                    )
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION7_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION7_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION7_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION8_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION8_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION8_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION9_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION9_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION9_PARAGRAPH2),
                    BlogParagraph(
                        graphic = listOf(
                            BlogGraphic(
                                graphicImage = "/blog3_before_after.jpg",
                                graphicAlt = "Before after"
                        ))

                    )
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION10_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION10_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION10_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG3_SECTION10_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION11_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION11_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION11_PARAGRAPH2),
                    BlogParagraph(
                        ResKey.BLOG3_SECTION11_PARAGRAPH3,
                        blogTableColumn = listOf(
                            BlogTableColumn(
                                ResKey.BLOG3_SECTION11_TABLE_HEADER1,
                                listOf(
                                    ResKey.BLOG3_SECTION11_ROW1_COL1,
                                    ResKey.BLOG3_SECTION11_ROW2_COL1,
                                    ResKey.BLOG3_SECTION11_ROW3_COL1,
                                    ResKey.BLOG3_SECTION11_ROW4_COL1,
                                    ResKey.BLOG3_SECTION11_ROW5_COL1,
                                    ResKey.BLOG3_SECTION11_ROW6_COL1,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG3_SECTION11_TABLE_HEADER2,
                                listOf(
                                    ResKey.BLOG3_SECTION11_ROW1_COL2,
                                    ResKey.BLOG3_SECTION11_ROW2_COL2,
                                    ResKey.BLOG3_SECTION11_ROW3_COL2,
                                    ResKey.BLOG3_SECTION11_ROW4_COL2,
                                    ResKey.BLOG3_SECTION11_ROW5_COL2,
                                    ResKey.BLOG3_SECTION11_ROW6_COL2,
                                )
                            )
                        )
                    )
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION12_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION12_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION12_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION13_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION13_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION13_PARAGRAPH2),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION14_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION14_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION14_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG3_SECTION14_PARAGRAPH3),
                )
            ),
            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION18_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION18_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION18_PARAGRAPH2),
                )
            ),
            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION19_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION19_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION19_PARAGRAPH2),
                )
            ),
            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION15_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG3_SECTION15_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG3_SECTION15_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG3_SECTION15_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG3_SECTION15_PARAGRAPH4),
                    BlogParagraph(ResKey.BLOG3_SECTION15_PARAGRAPH5),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION16_TITLE,
                paragraphList =listOf(
                    BlogParagraph(

                    blogTableColumn = listOf( BlogTableColumn(
                        columnTitle = ResKey.BLOG3_SECTION16_TABLE_HEADER1,
                        columnPoints = listOf(
                            ResKey.BLOG3_SECTION16_ROW1_COL1,
                            ResKey.BLOG3_SECTION16_ROW2_COL1,
                            ResKey.BLOG3_SECTION16_ROW3_COL1,
                            ResKey.BLOG3_SECTION16_ROW4_COL1,
                            ResKey.BLOG3_SECTION16_ROW5_COL1,
                            ResKey.BLOG3_SECTION16_ROW6_COL1,
                            ResKey.BLOG3_SECTION16_ROW7_COL1,
                            ResKey.BLOG3_SECTION16_ROW8_COL1,
                            ResKey.BLOG3_SECTION16_ROW9_COL1,
                            ResKey.BLOG3_SECTION16_ROW10_COL1,
                            ResKey.BLOG3_SECTION16_ROW14_COL1,
                            ResKey.BLOG3_SECTION16_ROW11_COL1,
                            ResKey.BLOG3_SECTION16_ROW12_COL1,
                            ResKey.BLOG3_SECTION16_ROW13_COL1,
                        )
                    ),
                    BlogTableColumn(
                        columnTitle = ResKey.BLOG3_SECTION16_TABLE_HEADER2,
                        columnPoints = listOf(
                            ResKey.BLOG3_SECTION16_ROW1_COL2,
                            ResKey.BLOG3_SECTION16_ROW2_COL2,
                            ResKey.BLOG3_SECTION16_ROW3_COL2,
                            ResKey.BLOG3_SECTION16_ROW4_COL2,
                            ResKey.BLOG3_SECTION16_ROW5_COL2,
                            ResKey.BLOG3_SECTION16_ROW6_COL2,
                            ResKey.BLOG3_SECTION16_ROW7_COL2,
                            ResKey.BLOG3_SECTION16_ROW8_COL2,
                            ResKey.BLOG3_SECTION16_ROW9_COL2,
                            ResKey.BLOG3_SECTION16_ROW10_COL2,
                            ResKey.BLOG3_SECTION16_ROW14_COL2,
                            ResKey.BLOG3_SECTION16_ROW11_COL2,
                            ResKey.BLOG3_SECTION16_ROW12_COL2,
                            ResKey.BLOG3_SECTION16_ROW13_COL2,
                        ))
                    ))
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG3_SECTION17_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        ResKey.BLOG3_SECTION17_SUBTITLE1,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG3_SECTION17_PARAGRAPH1),

                    BlogParagraph(
                        ResKey.BLOG3_SECTION17_SUBTITLE2,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG3_SECTION17_PARAGRAPH2),

                    BlogParagraph(
                        ResKey.BLOG3_SECTION17_SUBTITLE3,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG3_SECTION17_PARAGRAPH3),

                    BlogParagraph(
                        ResKey.BLOG3_SECTION17_SUBTITLE4,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG3_SECTION17_PARAGRAPH4),
                )
            )
        )
    ),
    BLOG2(
        title = ResKey.BLOG2_TITLE,
        image = "/how_to_get_more_customers.jpg",
        beginningDisplayText = ResKey.BLOG2_DISPLAY_TITLE,
        dateDisplay = "22 July 2026",
        date = 1783641600000L,
        pathToArticle = "/blog/ten-ways-sole-trader-can-get-more-customers",
        blogSectionList = listOf(

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION1_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION1_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION1_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION1_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION2_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION2_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION2_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION2_PARAGRAPH3),
                    BlogParagraph(
                        graphic = listOf(BlogGraphic(
                            graphicImage = "/google_business_profile.jpg",
                            graphicAlt = "Google Business Profile")
                        )
                    )
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION3_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION3_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION3_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION3_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION4_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION4_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION4_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION4_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG2_SECTION4_PARAGRAPH4),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION5_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION5_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION5_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION5_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION6_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION6_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION6_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION6_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG2_SECTION6_PARAGRAPH4),
                    BlogParagraph(
                        graphic = listOf(BlogGraphic(
                            graphicImage = "/blog2_before_after.jpg",
                            graphicAlt = "Before and After")
                        )
                    )
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION7_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION7_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION7_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION7_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG2_SECTION7_PARAGRAPH4),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION8_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION8_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION8_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION8_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG2_SECTION8_PARAGRAPH4),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION9_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION9_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION9_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION9_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION10_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION10_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION10_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION10_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION11_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION11_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION11_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION11_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG2_SECTION11_PARAGRAPH4),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION12_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        paragraphText = ResKey.BLOG2_SECTION12_PARAGRAPH1,
                        blogTableColumn = listOf(
                            BlogTableColumn(
                                ResKey.BLOG2_SECTION12_TABLE_HEADER1,
                                listOf(
                                    ResKey.BLOG2_SECTION12_ROW1_COL1,
                                    ResKey.BLOG2_SECTION12_ROW2_COL1,
                                    ResKey.BLOG2_SECTION12_ROW3_COL1,
                                    ResKey.BLOG2_SECTION12_ROW4_COL1,
                                    ResKey.BLOG2_SECTION12_ROW5_COL1,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG2_SECTION12_TABLE_HEADER2,
                                listOf(
                                    ResKey.BLOG2_SECTION12_ROW1_COL2,
                                    ResKey.BLOG2_SECTION12_ROW2_COL2,
                                    ResKey.BLOG2_SECTION12_ROW3_COL2,
                                    ResKey.BLOG2_SECTION12_ROW4_COL2,
                                    ResKey.BLOG2_SECTION12_ROW5_COL2,
                                )
                            )
                        )
                    )
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION13_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        paragraphText = ResKey.BLOG2_SECTION13_PARAGRAPH1,
                        blogTableColumn = listOf(
                            BlogTableColumn(
                                ResKey.BLOG2_SECTION13_TABLE_HEADER1,
                                listOf(
                                    ResKey.BLOG2_SECTION13_ROW1_COL1,
                                    ResKey.BLOG2_SECTION13_ROW2_COL1,
                                    ResKey.BLOG2_SECTION13_ROW3_COL1,
                                    ResKey.BLOG2_SECTION13_ROW4_COL1,
                                    ResKey.BLOG2_SECTION13_ROW5_COL1,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG2_SECTION13_TABLE_HEADER2,
                                listOf(
                                    ResKey.BLOG2_SECTION13_ROW1_COL2,
                                    ResKey.BLOG2_SECTION13_ROW2_COL2,
                                    ResKey.BLOG2_SECTION13_ROW3_COL2,
                                    ResKey.BLOG2_SECTION13_ROW4_COL2,
                                    ResKey.BLOG2_SECTION13_ROW5_COL2,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG2_SECTION13_TABLE_HEADER3,
                                listOf(
                                    ResKey.BLOG2_SECTION13_ROW1_COL3,
                                    ResKey.BLOG2_SECTION13_ROW2_COL3,
                                    ResKey.BLOG2_SECTION13_ROW3_COL3,
                                    ResKey.BLOG2_SECTION13_ROW4_COL3,
                                    ResKey.BLOG2_SECTION13_ROW5_COL3,
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG2_SECTION13_TABLE_HEADER4,
                                listOf(
                                    ResKey.BLOG2_SECTION13_ROW1_COL4,
                                    ResKey.BLOG2_SECTION13_ROW2_COL4,
                                    ResKey.BLOG2_SECTION13_ROW3_COL4,
                                    ResKey.BLOG2_SECTION13_ROW4_COL4,
                                    ResKey.BLOG2_SECTION13_ROW5_COL4,
                                )
                            )
                        )
                    ),

                    BlogParagraph(ResKey.BLOG2_SECTION13_PARAGRAPH2)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION15_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        paragraphText = ResKey.BLOG2_SECTION15_PARAGRAPH1,
                        listPoints = listOf(
                            ResKey.BLOG2_SECTION15_LIST1,
                            ResKey.BLOG2_SECTION15_LIST2,
                            ResKey.BLOG2_SECTION15_LIST3,
                            ResKey.BLOG2_SECTION15_LIST4,
                            ResKey.BLOG2_SECTION15_LIST5,
                            ResKey.BLOG2_SECTION15_LIST6,
                            ResKey.BLOG2_SECTION15_LIST7,
                            ResKey.BLOG2_SECTION15_LIST8,
                        )
                    ),
                    BlogParagraph(ResKey.BLOG2_SECTION15_PARAGRAPH2)
                )
            ),



            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION17_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        paragraphText = ResKey.BLOG2_SECTION17_SUBTITLE1,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG2_SECTION17_PARAGRAPH1),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG2_SECTION17_SUBTITLE2,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG2_SECTION17_PARAGRAPH2),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG2_SECTION17_SUBTITLE3,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG2_SECTION17_PARAGRAPH3),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG2_SECTION17_SUBTITLE4,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG2_SECTION17_PARAGRAPH4),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG2_SECTION17_SUBTITLE5,
                        isSubtitle = true
                    ),
                    BlogParagraph(ResKey.BLOG2_SECTION17_PARAGRAPH5),
                )
            ),
            BlogSection(
                sectionTitle = ResKey.BLOG2_SECTION16_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG2_SECTION16_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG2_SECTION16_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG2_SECTION16_PARAGRAPH3),
                )
            ),

        )
    ),
    BLOG1(
        title = ResKey.BLOG1_TITLE,
        image = "/blog1_img1.jpg",
        beginningDisplayText = ResKey.BLOG1_SECTION1_PARAGRAPH1,
        dateDisplay = "15 July 2026",
        date = 1783641600000L,
        pathToArticle = "/blog/why-every-sole-trader-needs-a-website",
        blogSectionList = listOf(

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION1_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION1_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG1_SECTION1_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG1_SECTION1_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG1_SECTION1_PARAGRAPH4)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION2_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION2_PARAGRAPH1),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG1_SECTION2_PARAGRAPH2,
                        listPoints = listOf(
                            ResKey.BLOG1_SECTION2_LIST1,
                            ResKey.BLOG1_SECTION2_LIST2,
                            ResKey.BLOG1_SECTION2_LIST3,
                            ResKey.BLOG1_SECTION2_LIST4
                        )
                    ),

                    BlogParagraph(ResKey.BLOG1_SECTION2_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG1_SECTION2_PARAGRAPH4)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION3_TITLE,
                paragraphList = listOf(

                    BlogParagraph(ResKey.BLOG1_SECTION3_PARAGRAPH1),

                    BlogParagraph(ResKey.BLOG1_SECTION3_PARAGRAPH2),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG1_SECTION3_PARAGRAPH3,
                        listPoints = listOf(
                            ResKey.BLOG1_SECTION3_LIST1,
                            ResKey.BLOG1_SECTION3_LIST2,
                            ResKey.BLOG1_SECTION3_LIST3,
                            ResKey.BLOG1_SECTION3_LIST4
                        )
                    ),

                    BlogParagraph(ResKey.BLOG1_SECTION3_PARAGRAPH4),
                    BlogParagraph(ResKey.BLOG1_SECTION3_PARAGRAPH5)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION4_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION4_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG1_SECTION4_PARAGRAPH2),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG1_SECTION4_PARAGRAPH3,
                        listPoints = listOf(
                            ResKey.BLOG1_SECTION4_LIST1,
                            ResKey.BLOG1_SECTION4_LIST2,
                            ResKey.BLOG1_SECTION4_LIST3,
                            ResKey.BLOG1_SECTION4_LIST4
                        )
                    ),

                    BlogParagraph(ResKey.BLOG1_SECTION4_PARAGRAPH4)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION5_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION5_PARAGRAPH1),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG1_SECTION5_PARAGRAPH2,
                        listPoints = listOf(
                            ResKey.BLOG1_SECTION5_LIST1,
                            ResKey.BLOG1_SECTION5_LIST2,
                            ResKey.BLOG1_SECTION5_LIST3,
                            ResKey.BLOG1_SECTION5_LIST4,
                            ResKey.BLOG1_SECTION5_LIST5
                        )
                    ),

                    BlogParagraph(ResKey.BLOG1_SECTION5_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG1_SECTION5_PARAGRAPH4)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION6_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION6_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG1_SECTION6_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG1_SECTION6_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG1_SECTION6_PARAGRAPH4)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION7_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION7_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG1_SECTION7_PARAGRAPH2),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG1_SECTION7_PARAGRAPH3,
                        listPoints = listOf(
                            ResKey.BLOG1_SECTION7_LIST1,
                            ResKey.BLOG1_SECTION7_LIST2,
                            ResKey.BLOG1_SECTION7_LIST3,
                            ResKey.BLOG1_SECTION7_LIST4,
                            ResKey.BLOG1_SECTION7_LIST5,
                            ResKey.BLOG1_SECTION7_LIST6,
                            ResKey.BLOG1_SECTION7_LIST7,
                            ResKey.BLOG1_SECTION7_LIST8
                        )
                    ),

                    BlogParagraph(ResKey.BLOG1_SECTION7_PARAGRAPH4),
                    BlogParagraph(ResKey.BLOG1_SECTION7_PARAGRAPH5)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION8_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION8_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG1_SECTION8_PARAGRAPH2),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG1_SECTION8_PARAGRAPH3,
                        listPoints = listOf(
                            ResKey.BLOG1_SECTION8_LIST1,
                            ResKey.BLOG1_SECTION8_LIST2,
                            ResKey.BLOG1_SECTION8_LIST3,
                            ResKey.BLOG1_SECTION8_LIST4,
                            ResKey.BLOG1_SECTION8_LIST5
                        )
                    ),

                    BlogParagraph(ResKey.BLOG1_SECTION8_PARAGRAPH4),
                    BlogParagraph(ResKey.BLOG1_SECTION8_PARAGRAPH5)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION9_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION9_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG1_SECTION9_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG1_SECTION9_PARAGRAPH3)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION10_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION10_PARAGRAPH1),

                    BlogParagraph(
                        paragraphText = ResKey.BLOG1_SECTION10_PARAGRAPH2,
                        listPoints = listOf(
                            ResKey.BLOG1_SECTION10_LIST1,
                            ResKey.BLOG1_SECTION10_LIST2,
                            ResKey.BLOG1_SECTION10_LIST3,
                            ResKey.BLOG1_SECTION10_LIST4,
                            ResKey.BLOG1_SECTION10_LIST5,
                            ResKey.BLOG1_SECTION10_LIST6
                        )
                    ),

                    BlogParagraph(ResKey.BLOG1_SECTION10_PARAGRAPH3)
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION11_TITLE,
                paragraphList = listOf(

                    BlogParagraph(ResKey.BLOG1_SECTION11_SUBTITLE1,isSubtitle = true),
                    BlogParagraph(ResKey.BLOG1_SECTION11_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG1_SECTION11_SUBTITLE2, isSubtitle = true),
                    BlogParagraph(ResKey.BLOG1_SECTION11_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG1_SECTION11_SUBTITLE3, isSubtitle = true),
                    BlogParagraph(ResKey.BLOG1_SECTION11_PARAGRAPH3),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION12_TITLE,
                paragraphList = listOf(
                    BlogParagraph(
                        blogTableColumn = listOf(
                            BlogTableColumn(
                                ResKey.BLOG1_SECTION12_TABLE_HEADER1,
                                listOf(
                                    ResKey.BLOG1_SECTION12_ROW1_COL1,
                                    ResKey.BLOG1_SECTION12_ROW2_COL1,
                                    ResKey.BLOG1_SECTION12_ROW3_COL1,
                                    ResKey.BLOG1_SECTION12_ROW4_COL1,
                                    ResKey.BLOG1_SECTION12_ROW5_COL1
                                )
                            ),
                            BlogTableColumn(
                                ResKey.BLOG1_SECTION12_TABLE_HEADER2,
                                listOf(
                                    ResKey.BLOG1_SECTION12_ROW1_COL2,
                                    ResKey.BLOG1_SECTION12_ROW2_COL2,
                                    ResKey.BLOG1_SECTION12_ROW3_COL2,
                                    ResKey.BLOG1_SECTION12_ROW4_COL2,
                                    ResKey.BLOG1_SECTION12_ROW5_COL2
                                )
                            )
                        )
                    )
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION13_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION13_PARAGRAPH1),
                )
            ),

            BlogSection(
                sectionTitle = ResKey.BLOG1_SECTION14_TITLE,
                paragraphList = listOf(
                    BlogParagraph(ResKey.BLOG1_SECTION14_PARAGRAPH1),
                    BlogParagraph(ResKey.BLOG1_SECTION14_PARAGRAPH2),
                    BlogParagraph(ResKey.BLOG1_SECTION14_PARAGRAPH3),
                    BlogParagraph(ResKey.BLOG1_SECTION14_PARAGRAPH4),
                    BlogParagraph(ResKey.BLOG1_SECTION14_PARAGRAPH5)
                )
            )
        )
    )
}

data class BlogSection(
    val sectionTitle:ResKey,
    val paragraphList:List<BlogParagraph>,

)

data class BlogParagraph(
    val paragraphText:ResKey?=null,
    val isSubtitle:Boolean = false,
    val listPoints:List<ResKey> = emptyList(),
    val pointsType:PointsType = PointsType.BULLET_POINTS,
    val blogTableColumn:List<BlogTableColumn> = emptyList(),
    val graphic: List<BlogGraphic>? = null
)

data class BlogTableColumn(
    val columnTitle:ResKey,
    val columnPoints:List<ResKey>
)

data class BlogGraphic(
    val graphicImage: String,
    val graphicAlt: String,
    val showShadow:Boolean = true
)

enum class PointsType(){
    BULLET_POINTS,CHECKBOX
}


